export class SupplierOrderDetailsModel {
  public supplyName: string;
  public quantity: number;
  public unitOfMeasurementShortName: string;
  public grossPrice: number;
  public date: string;
  public invoiceId: string;
}
